import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getDirectSalesNetworkCriteria = createSelector(
  (state: Store) => state.dealManagement.directSales.networkCriteria,
  (networkCriteria) => networkCriteria,
);

export const getBudgetCriteria = createSelector(
  (state: Store) => state.dealManagement.directSales.budgetCriteria,
  (budgetCriteria) => budgetCriteria,
);

export const getFramesCriteria = createSelector(
  (state: Store) => state.dealManagement.directSales.framesCriteria,
  (framesCriteria) => framesCriteria,
);

export const getImpressionsCriteria = createSelector(
  (state: Store) => state.dealManagement.directSales.impressionsCriteria,
  (impressionsCriteria) => impressionsCriteria,
);
